import { render, staticRenderFns } from "./audio-viewer.vue?vue&type=template&id=dfbd1b92&"
import script from "./audio-viewer.vue?vue&type=script&lang=js&"
export * from "./audio-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports